module.exports = __webpack_public_path__ + "img/user_icon.08938699.svg";